<template>
    <div class="context common_add_view">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <el-form :model="form" :rules="rules" ref="form" label-width="200px">
                <el-form-item label="产品名称：">
                    <span>{{form.product_name}}</span>
                </el-form-item>
                <el-form-item label="产品代码：">
                    <span>{{form.product_code}}</span>
                </el-form-item>
                <el-form-item label="周期最高分：" prop="count">
                    <el-input-number v-model="form.cycle_max_scores"
                                     controls-position="right"
                                     :min="1" :max="1000"></el-input-number>
                </el-form-item>
                <el-form-item label="产品规格：" prop="repeat">
                    <el-radio-group v-model="form.product_type" @input="changeRepeat">
                        <el-radio :label="1">单规格</el-radio>
                        <el-radio :label="2">多规格</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单支积分数：" prop="count" v-if="form.product_type == 1">
                    <el-input-number v-model="form.per_score"
                                     controls-position="right"
                                     :min="1" :max="200"></el-input-number>
                </el-form-item>
                <div v-if="form.product_type == 2">
                    <el-form-item label="单支积分数（规格1）：" prop="sub1">
                        <el-input-number v-model="form.per_score1"
                                         controls-position="right"
                                         :min="1" :max="200"></el-input-number>
                    </el-form-item>
                    <el-form-item label="单支积分数（规格2）：" prop="sub2">
                        <el-input-number v-model="form.per_score2"
                                         controls-position="right"
                                         :min="1" :max="200"></el-input-number>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="submitNow">提交</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import {clone} from "@/global/utils";

    export default {
        name: "addView",
        data() {
            return {
                viewTitle: '修改积分设置',

                form: {
                    cycle_max_scores: 1,
                    product_type: 1, //  1 单规格 2 多规格
                    per_score: 1,
                    per_score1: 1,
                    per_score2: 1,
                },
                rules: {
                    event_name: [{required: true, message: '请选择事件类型', target: 'blur'}],
                },
            }
        },
        computed: {
            ...mapState('manageData', {
                jifen_set_data: 'jifen_set_data'
            }),
            calcMax() {
                let nums = this.form.maximum_type == 2 ? 500 : 200;
                return nums
            }
        },
        mounted() {
            console.log(this.jifen_set_data, '20');
            if (this.jifen_set_data) {
                this.form = clone(this.jifen_set_data);
                this.form.product_type = this.form.product_type ? this.form.product_type : 1
            }
        },
        methods: {
            back() {
                this.$emit('changeTopTab', 'tableView')
            },

            changeRepeat() {
                this.form.per_score = 1;
                this.form.per_score1 = 1;
                this.form.per_score2 = 1;
            },

            submitNow() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };
                        this.httpPut(`/product/${params.pid}`, params).then(res => {
                            this.$message.success('修改成功！');
                            this.back()
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>